module.exports = __webpack_public_path__ + "img/contactless_mobile_fr@2x.bef5b0d6.png";